module.exports = __webpack_public_path__ + "static/media/averta-normal.30559e37.woff2";